import { buildSectionSelector, normalizeSectionId, sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

/**
 * Hydrates a section using the Section Rendering API preserving states.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') {
    return;
  }

  // Header (and similar) morphs while a nested modal is open causes a visible layout jump (e.g.
  // cart drawer flex/height). Wait until all dialogs in this section are closed before morphing.
  const blockingDialog = section.querySelector('dialog[open]');
  if (blockingDialog instanceof HTMLDialogElement) {
    blockingDialog.addEventListener('close', () => void hydrateSection(sectionId, url), { once: true });
    return;
  }

  await sectionRenderer.renderSection(normalizedId, { cache: false, url });

  section.dataset.hydrated = 'true';
}

/**
 * Hydrates a section using the Section Rendering API preserving states, when
 * the DOM is ready.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
export async function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}
